const login = {
	signIn:'登录',
	register:'注册'
}

export default login